import { render, staticRenderFns } from "./InputPadding.vue?vue&type=template&id=92f8c740&"
import script from "./InputPadding.vue?vue&type=script&lang=js&"
export * from "./InputPadding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports